import { Validators } from '@angular/forms';
import { TicketActionDef } from './ticket-actions.service';
import { emailOrPhoneValidator } from '@ridango/core/lib/validators/email-or-phone.validator';
import { TicketStatus } from '@ridango/components';
import { FareContractStatus } from '@ridango/components/lib/account-tickets-ngrx/models/ticket-status.model';

export const TICKET_ACTIONS: readonly TicketActionDef[] = [
    {
        id: 'SEND',
        labelKey: 'SEND_TICKET',
        cssClass: {
            onSheet: 'var-app-light-dark:order-2 var-app-light-dark:text-primary font-semibold',
            onDetails:
                'btn--link btn var-app-light-dark:btn-none btn--maximal btn--primary orb-app-light-dark:text-secondary orb-app-light-dark:border-none orb-app-light-dark:bg-transparent btn--big btn--icon var-app-light-dark:btn--icon-none margin-bottom-10 link--no-line link--no-hover vl-app-light:bg-transparent vl-app-light:text-secondary vl-app-light:border-none vl-app-light:focus:border-none vl-app-light:shadow-none sr-app-light:h-16 sr-app-light:text-[1rem] sr-app-light:font-bold rounded-lg var-app-light-dark:font-semibold var-app-light-dark:text-primary var-app-light-dark:bg-transparent  var-app-light-dark:shadow-none var-app-light-dark:border-none var-app-light-dark:text-[1rem] var-app-light-dark:order-2 var-app-light-dark:my-4'
        },
        show: ({ ticket, env, isHistory }) => {
            return (
                env.TICKET_ACTIONS?.includes('SEND_TICKET') &&
                (env.IS_NEW_AFC
                    ? ticket.allowedActions?.transferable
                    : !ticket.validated &&
                      ticket.status !== TicketStatus.Returned &&
                      ticket.status.toLowerCase() !== FareContractStatus.EXPIRED.toLowerCase() &&
                      !ticket.activated &&
                      !isHistory &&
                      (ticket.transferable || ['Q', 'M'].includes(ticket.cardType)))
            );
        },
        run: async (ctx, di) => {
            const validator = ctx.env.SEND_TICKET_IDENTIFIER === 'email' ? Validators.email : emailOrPhoneValidator;

            const fg = di.fb.group({
                identifier: ['', [Validators.required, validator]]
            });
            await di.openTicketModal('SEND_TICKET', fg, ctx);
            di.sendTicketAnalyticEvent('Ticket details - send ticket');
        }
    },
    {
        id: 'RETURN',
        labelKey: 'RETURN_TICKET',
        cssClass: {
            onDetails:
                'btn--link btn btn--maximal btn--primary btn--icon link--no-line link--no-hover orb-app-light-dark:text-secondary'
        },
        show: ({ env, ticket }) =>
            env.TICKET_ACTIONS?.includes('RETURN_TICKET') &&
            (env.IS_NEW_AFC ? ticket.allowedActions?.refundable : !ticket.validated),
        run: async (ctx, di) => {
            const fg = di.fb.group({ travelCardNumber: ['', Validators.required] });
            await di.openTicketModal('RETURN_TICKET', fg, ctx);
        }
    },
    {
        id: 'MANUAL_ACTIVATE',
        labelKey: 'TICKET_ACTIVATE_MANUAL_BTN',
        cssClass: {
            onSheet: 'var-app-light-dark:order-1 var-app-light-dark:text-primary font-semibold',
            onDetails:
                'btn-primary btn-primary--sharp-dark jk-light:text-white orb-app-light:text-black orb-app-light:bg-primary my-4 box-border w-full bg-secondary p-4 text-center text-primary dark:text-contrast-black var-app-light-dark:order-1'
        },
        show: ({ env, ticket, isTopUp }) =>
            !isTopUp &&
            env.TICKET_MANUAL_ACTIVATION_ALLOWED &&
            !ticket.validated &&
            (env.IS_NEW_AFC
                ? ticket.startDate == null &&
                  ticket.endDate == null &&
                  ticket.type === 'SINGLE_PRODUCT' &&
                  ticket.status === 'CONFIRMED'
                : true),
        run: async (ctx, di) => {
            await di.activateTicketModal(ctx, () => {
                ctx.refresh?.emit();
            });
        }
    },
    {
        id: 'REACTIVATE',
        labelKey: 'TICKET_REACTIVATE_MANUAL_BTN',
        cssClass: {
            onSheet: 'dark:text-contrast-black font-semibold',
            onDetails:
                'btn-primary btn-primary--sharp-dark orb-app-light:bg-primary orb-app-light:text-black jk-light:text-white my-4 box-border w-full bg-secondary p-4 text-center text-primary dark:text-contrast-black'
        },
        show: ({ env, ticket }) =>
            env.TICKET_ACTIONS?.includes('AWAITING_REACTIVATION') && ticket.status === 'AWAITING_REACTIVATION',
        run: ({ ticket, refresh }, di) => {
            di.ticketsFacade.reactivateTicket(String(ticket.id ?? ticket.docNum));
            refresh?.emit();
        }
    },
    {
        id: 'BUY_AGAIN',
        labelKey: 'BUY_TICKET_AGAIN',
        cssClass: {
            onSheet: 'var-app-light-dark:text-primary dark:text-contrast-black font-semibold',
            onDetails:
                'btn--link btn btn--maximal btn--big margin-bottom-10 link--no-line link--no-hover orb-app-light-dark:text-secondary vl-app-light:bg-transparent vl-app-light:text-secondary vl-app-light:shadow-none sr-app-light:bg-transparent sr-app-light:text-secondary sr-app-light:outline-0 sr-app-light:shadow-none sr-app-light:mb-0 active:border-[3px] active:border-solid active:border-primary'
        },
        show: ({ env, isHistory, ticket }) =>
            isHistory && env.TICKET_ACTIONS?.includes('BUY_TICKET_AGAIN') && ticket.allowedActions?.repurchasable,
        run: (ctx, di) => {
            di.buyTicketAgain(ctx);
        }
    },
    {
        id: 'REMOVE_HISTORY',
        labelKey: 'REMOVE_HISTORY_TICKET',
        cssClass: {
            onDetails:
                'btn--link btn btn--maximal btn--big margin-bottom-10 link--no-line link--no-hover vl-app-light:bg-transparent vl-app-light:text-secondary vl-app-light:shadow-none sr-app-light:bg-transparent sr-app-light:text-secondary sr-app-light:outline-0 sr-app-light:shadow-none sr-app-light:mb-0 active:border-[3px] active:border-solid active:border-primary'
        },
        show: ({ env, isHistory }) => isHistory && env.TICKET_ACTIONS?.includes('REMOVE_HISTORY_TICKET'),
        run: (ctx, di) => {
            di.removeExpiredTicket(ctx);
        }
    },
    {
        id: 'LEND',
        labelKey: 'LEND_TICKET',
        cssClass: {
            onSheet: 'dark:text-contrast-black font-semibold',
            onDetails:
                'btn btn--maximal margin-top-10 link--no-line link--no-hover orb-app-light-dark:text-secondary text-[var(--color-brand-primary)]'
        },
        show: ({ env, ticket, isAuth }) =>
            env.TICKET_ACTIONS?.includes('LEND_TICKET') &&
            (env.IS_NEW_AFC
                ? ticket.allowedActions?.lendable
                : ticket.lendable && ticket.isOwner && !ticket.loaned && ticket.activated && isAuth),
        run: async (ctx, di) => {
            const fg = di.fb.group({
                email: ['', [Validators.required, ctx.env.IS_NEW_AFC ? emailOrPhoneValidator : Validators.email]],
                lentTo: [new Date(), Validators.required]
            });
            await di.openTicketModal('LEND_TICKET', fg, ctx);
            di.sendTicketAnalyticEvent('Ticket details - lend ticket');
        }
    },
    {
        id: 'FAVORITE',
        labelKey: 'MARK_AS_FAVORITE_TICKET',
        dynamicLabel: ({ isFavourite }) => (isFavourite ? 'UNMARK_AS_FAVORITE_TICKET' : 'MARK_AS_FAVORITE_TICKET'),
        cssClass: {
            onDetails:
                'btn--link btn btn--maximal btn--big margin-bottom-10 link--no-line link--no-hover orb-app-light-dark:text-secondary vl-app-light:bg-transparent vl-app-light:text-secondary vl-app-light:shadow-none sr-app-light:bg-transparent sr-app-light:text-secondary sr-app-light:outline-0 sr-app-light:shadow-none sr-app-light:mb-0 active:border-[3px] active:border-solid active:border-primary'
        },
        show: ({ env, isAuth, ticket }) =>
            env.TICKET_ACTIONS?.includes('ADD_TO_FAVORITE_TICKET') && ticket.isOwner && !ticket.loaned && isAuth,
        run: ({ ticket, isFavourite, isHistory, env, startDateStr, endDateStr }, di) => {
            const fav = di.favoritesFacade;
            if (isFavourite) {
                fav.deleteFavoriteTicket(ticket.productId);
            } else {
                const payload: any = {
                    docNum: ticket.docNum?.toString(),
                    categoryCode: ticket.categoryType || '',
                    productId: ticket.productId
                };

                if (isHistory) {
                    payload.includeReturnedTickets = true;
                    payload.includeCancelledTickets = true;

                    if (env.CHANNEL) {
                        payload.channels = [env.CHANNEL];
                    }

                    if (startDateStr) {
                        payload.startDateStr = startDateStr;
                    }
                    if (endDateStr) {
                        payload.endDateStr = endDateStr;
                    }
                }

                fav.addFavoriteTicket(payload);
            }
            di.sendTicketAnalyticEvent(`Ticket details - ${isFavourite ? 'Unmark' : 'Mark'} as favorite`);
        }
    },
    {
        id: 'PDF',
        labelKey: 'PAYMENT_RESULT_TEXT_DOWNLOAD_PDF',
        cssClass: {
            onSheet:
                'var-app-light-dark:order-3 var-app-light-dark:text-primary dark:text-contrast-black font-semibold',
            onDetails:
                'btn--link btn btn--maximal btn--big margin-bottom-10 link--no-line link--no-hover orb-app-light-dark:text-secondary vl-app-light:bg-transparent vl-app-light:text-secondary vl-app-light:shadow-none sr-app-light:bg-transparent sr-app-light:text-secondary sr-app-light:outline-0 sr-app-light:shadow-none sr-app-light:mb-0 active:border-[3px] active:border-solid active:border-primary var-app-light-dark:order-3 pn-light-dark:hidden tallinn-light-dark:hidden'
        },
        show: ({ env, ticket }) => {
            if (env.IS_NEW_AFC) {
                return ticket.receiptDownloadable ?? false;
            } else {
                // For old AFC, keep showing PDF button for all tickets as the backend might not provide receiptDownloadable field
                return true;
            }
        },
        run: async ({ ticket }, di) => {
            const loader = await di.loadingCtrl.create({
                message: di.translate.instant('BUTTON_LOADER_TEXT')
            });
            await loader.present();
            await di.historyFacade.getPdfPut(ticket.pdfToken, ticket.id?.toString());
            await loader.dismiss();
        }
    },
    {
        id: 'RETURN_LEND',
        labelKey: 'RETURN_TICKET',
        dynamicLabel: ({ ticket }) => (ticket?.isOwner ? 'REQUEST_RETURN' : 'RETURN_TICKET'),
        cssClass: {
            onSheet: 'dark:text-contrast-black font-semibold',
            onDetails:
                'btn btn--maximal margin-top-10 link--no-line link--no-hover orb-app-light-dark:text-secondary text-[var(--color-brand-primary)]'
        },
        show: ({ env, ticket, isHistory }) =>
            ticket.loaned &&
            env.TICKET_ACTIONS?.includes('RETURN_LEND_TICKET') &&
            !env.SHOW_SELECTOR_TIME_LEND_TICKET &&
            !isHistory,
        run: async (ctx, di) => {
            const fg = di.fb.group({});

            const actionName = ctx.ticket?.isOwner ? 'RECALL_LEND_TICKET' : 'RETURN_LEND_TICKET';

            await di.openTicketModal(actionName, fg, ctx);
        }
    }
];
